import { render, staticRenderFns } from "./HkButton.vue?vue&type=template&id=b30b7614&scoped=true&"
import script from "./HkButton.vue?vue&type=script&lang=js&"
export * from "./HkButton.vue?vue&type=script&lang=js&"
import style0 from "./HkButton.vue?vue&type=style&index=0&id=b30b7614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30b7614",
  null
  
)

export default component.exports